import React from 'react';
import MdEditor from 'react-markdown-editor-lite';
import MarkdownIt from 'markdown-it';
import {filesUpload} from "../api/files";

const mdParser = new MarkdownIt();

/**
 * MarkdownEditor
 * @param height {number | null}
 * @param value {string}
 * @param mode {1 | 2} 1: Edit mode  2: View mode
 * @param onChange {(data: {text: string;html: string;}) => void}
 * @returns {null | JSX.Element}
 * @constructor
 */

export const MarkdownEditor = ({height, value = '', mode = 1, onChange}) => {
    const handleImageUpload = async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const ret = await filesUpload(formData)
        return ret.data.file_url
    }

    if (mode === 1) {
        // Edit mode
        return <MdEditor
            view={{menu: true, md: true, html: false}}
            canView={{menu: true, md: false, html: false, fullScreen: false, both: false, hideMenu: false}}
            value={value}
            style={{height}}
            renderHTML={text => mdParser.render(text)}
            onImageUpload={handleImageUpload}
            onChange={onChange} />
    } else if (mode === 2) {
        // View mode
        return <MdEditor
            view={{menu: false, md: false, html: true}}
            canView={{menu: true, md: false, html: false, fullScreen: false, both: false, hideMenu: false}}
            value={value}
            style={{height}}
            renderHTML={text => mdParser.render(text)} />
    }
    return null
}
